import { useMediaQuery } from '@uidotdev/usehooks'

// Définissez vos breakpoints Tailwind ici
export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1440,
  '3xl': 1536,
}

export const useTailwindBreakpoint = (breakpoint) => {
  const [key, operator] = breakpoint.split(/(?=[+-])/)
  const breakpointValue = breakpoints[key]

  const mediaQuery =
    operator === '+'
      ? `(min-width: ${breakpointValue}px)`
      : `(max-width: ${breakpointValue - 1}px)`

  return useMediaQuery(mediaQuery)
}

export default useTailwindBreakpoint
